import { render, staticRenderFns } from "./register_member.vue?vue&type=template&id=dd1f2bee&scoped=true&"
import script from "./register_member.vue?vue&type=script&lang=js&"
export * from "./register_member.vue?vue&type=script&lang=js&"
import style0 from "./register_member.vue?vue&type=style&index=0&id=dd1f2bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1f2bee",
  null
  
)

export default component.exports